<template>
  <div class="head-content">
    
    <!-- v-if="isMaxScreen" -->
    <div class="head-box" >
      <div class="head">
        <img src="../../assets/image/head/logo.png" alt="" class="logo">

        <div class="tabs">
          <div class="tab" v-for="(tab, index) in tabs" :key="index" :class="{ 'active': activeTab === index }" @click="activeTabClick(index)">{{ tab.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      activeTab: 0,
      tabs: [
        { title: 'Home' },
        { title: 'Exchange offer' },
        { title: 'FAQ' }
      ]
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      },
    })
  },
  methods: {
  },
  created(){
    console.log(this.$route.path)
    if(this.$route.path == '/faq'){
      this.activeTab = 2
    }
  },
  mounted () {
    
  },
  methods: {
    activeTabClick(index){
     
      if(index==0){
        this.activeTab = 0;
        this.$router.push('/home');
      } else if(index == 1){
        window.open("https://event.realme.com/in/realme-exchange-brief")
      }
      else if(index == 2){
        this.activeTab = 2;
        this.$router.push('/faq');
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 980px) {
  ::-webkit-scrollbar {
    width: 0px;
  }
  ::-webkit-scrollbar {
    display: none;
  }

  .head-content{
    height: 88px;
  }

  .head {
    position: fixed;
    top: 0;
    // width: 100%;
    z-index: 100;
    width: 100%;
    height: 88px;
    overflow-y: scroll;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 160px;
      height: 48px;
      margin-left: 24px;
    }
  }

  .tabs {
    display: flex;
    margin-right: 24px;
  }

  .tab {
    padding: 24px;
    cursor: pointer;
    position: relative;
  }

  .tab.active::after {
      content: '';
      position: absolute;
      bottom: 10px;
      left: 50%;
      width: 30px;
      margin-left: -15px;
      height: 4px; 
      border-radius: 2px;
      background: #FF9600;
  }
}
@media (min-width: 981px) {
  .head-content {
    background: #fff;
    height: 80px!important;
  }
  .head-box{
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    background: #fff;
  }
  .head {
    width: 1200px!important;
    height: 80px!important;
    width: 100%;
    line-height: 80px;
    background: #fff;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .logo {
      width: 160px;
      height: 48px;
    }
  }

  .tabs {
    display: flex;
    margin-right: 24px;
  }

  .tab {
    // padding: 0 24px;
    width: 160px;
    cursor: pointer;
    position: relative;
    color: #333;
    font-family: "PingFang SC";
  }

  .tab.active{
    font-weight: bold;
    color: #111;
  }

  .tab.active::after {
      content: '';
      position: absolute;
      bottom: 15px;
      left: 50%;
      width: 30px;
      margin-left: -15px;
      height: 4px; 
      border-radius: 2px;
      background: #FF9600;
  }
}
</style>
